const history = []

export const setHistory = (previousRoute) => {
    history.push(previousRoute)
} 

export const getLastRouter = () => {
    return history[history.length - 1];
}

export const popLastHistory = () => {
    history.pop();
}